import { createAction, getType } from "typesafe-actions";
import { RequestState } from "../../../constants/request-state";

export interface NotesRequestState {
    [id: number]: RequestState
}

export const notesRequestActions = {
    stateChanged: createAction("notes/STATE_CHANGED",
        resolve => (id: number, requestState: RequestState) => resolve({ id, requestState })),
}

export function NotesRequestReducer(state: NotesRequestState = {}, action: ReturnType<typeof notesRequestActions.stateChanged>) {
    switch (action.type) {
        case getType(notesRequestActions.stateChanged): {
            const { id, requestState } = action.payload;
            return {
                ...state,
                [id]: requestState
            };
        }
        default:
            return state;
    }
}   